import {useSelf} from "./useSelf.ts";
import {Button, DialogActions, DialogContent, DialogTitle, Typography} from "@mui/joy";
import {useTranslation} from "react-i18next";
import {statusPalettes, useSelfShiftInfo} from "./diary.tsx";
import {useStampAgentMutation} from "../tq/tqx.tsx";

export interface ShiftBreakDialogProps {
    onClose: () => void;
}

function StartShiftDialogGu({onClose}: ShiftBreakDialogProps) {
    const {t} = useTranslation();
    const {data: self} = useSelf();
    const {mutateAsync: stampen} = useStampAgentMutation();

    if (!self) {
        return null;
    }

    return <>
        <DialogTitle>
            <Typography level="title-lg">{t("diary.startShiftDialogTitle")}</Typography>
        </DialogTitle>
        <DialogContent>
            <Typography level="body-md">{t("diary.startShiftDialogPrompt")}</Typography>
        </DialogContent>
        <DialogActions>
            <Button variant="solid" color={statusPalettes.onDuty} onClick={() => {
                void stampen({
                    food: {
                        agentId: self.id, flavor: "SHIFT_START"
                    }
                }).then(() => {
                    onClose();
                });
            }}>{t("diary.beginShift")}</Button>
            <Button variant="soft" color={statusPalettes.out} onClick={() => {
                onClose();
            }}>{t("cancel")}</Button>
        </DialogActions>
    </>
}

function OnBreakShiftDialogGu({onClose}: ShiftBreakDialogProps) {
    const {t} = useTranslation();
    const {data: self} = useSelf();
    const {mutateAsync: stampen} = useStampAgentMutation();
    if (!self) {
        return null;
    }
    return <>
        <DialogTitle>
            <Typography level="title-lg">{t("diary.onBreakShiftDialogTitle")}</Typography>
        </DialogTitle>
        <DialogContent>
            <Typography level="body-md">{t("diary.onBreakShiftDialogPrompt")}</Typography>
        </DialogContent>
        <DialogActions>
            <Button variant="solid" color={statusPalettes.onDuty}
                    onClick={() => {
                        void stampen({
                            food: {agentId: self.id, flavor: "BREAK_END"}
                        }).then(() => {
                            onClose();
                        });
                    }}>{t("diary.endBreak")}</Button>
            <Button variant="solid" color="danger" onClick={() => {
                void stampen({
                    food: {agentId: self.id, flavor: "SHIFT_END"}
                }).then(() => {
                    onClose();
                });
            }}>{t("diary.endShift")}</Button>
            <Button variant="soft" color={statusPalettes.onBreak}
                    onClick={() => {
                        onClose();
                    }}>{t("cancel")}</Button>
        </DialogActions>
    </>
}

function OnDutyShiftDialogGu({onClose}: ShiftBreakDialogProps) {
    const {t} = useTranslation();
    const {data: self} = useSelf();
    const {mutateAsync: stampen} = useStampAgentMutation();
    if (!self) {
        return null;
    }
    return <>
        <DialogTitle>
            <Typography level="title-lg">{t("diary.onBreakShiftDialogTitle")}</Typography>
        </DialogTitle>
        <DialogContent>
            <Typography level="body-md">{t("diary.onBreakShiftDialogPrompt")}</Typography>
        </DialogContent>
        <DialogActions>
            <Button variant="solid" color="danger" onClick={() => {
                void stampen({
                    food: {agentId: self.id, flavor: "SHIFT_END"}
                }).then(() => {
                    onClose();
                });
            }}>{t("diary.endShift")}</Button>
            <Button variant="solid" color={statusPalettes.onBreak} onClick={() => {
                void stampen({
                    food: {agentId: self.id, flavor: "BREAK_START"}
                }).then(() => {
                    onClose();
                });
            }}>{t("diary.beginBreak")}</Button>
            <Button variant="soft" color={statusPalettes.onDuty} onClick={() => {
                onClose();
            }}>{t("cancel")}</Button>
        </DialogActions>
    </>
}


export function ShiftBreakDialogGu(props: ShiftBreakDialogProps) {
    const {data} = useSelfShiftInfo();
    if (!data) {
        return null;
    }
    switch (data.status) {
        case "initial":
        case "out":
            return StartShiftDialogGu(props);
        case "onBreak":
            return OnBreakShiftDialogGu(props);
        case "onDuty":
            return OnDutyShiftDialogGu(props);
    }
}

